import useMeetData from '@usas/ui-web/state/meet/UseMeetData';

const useMeetRecon = () => {
  const { meetState } = useMeetData();

  return {
    meetId: meetState.objData?.meetId || -1
  };
};

export default useMeetRecon;